import { createFileRoute } from '@tanstack/react-router';
import CongregationCreate from '~/containers/CongregationCreate';

export const Route = createFileRoute('/congregations/new')({
  component: CongregationCreate,
  validateSearch(search): { from?: string } {
    return {
      from: (search.from as string) || undefined,
    };
  },
});
